var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5391,
    cy: 12,
    r: 12,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.39 8.6731C14.39 9.66892 13.5425 10.5554 12.5391 10.5554C11.5356 10.5554 10.6881 9.66892 10.6881 8.6731C10.6881 7.64407 11.5671 6.6945 12.5391 6.6945C13.511 6.6945 14.39 7.64407 14.39 8.6731ZM17.8446 15.1853C17.8446 15.6365 17.6004 16.1354 16.7862 16.5598C15.9491 16.9961 14.5761 17.3056 12.5391 17.3056C10.5021 17.3056 9.12904 16.9961 8.29189 16.5598C7.47769 16.1354 7.23356 15.6365 7.23356 15.1853C7.23356 14.8361 7.56182 14.3066 8.59139 13.8236C9.5658 13.3665 10.9608 13.0649 12.5391 13.0649C14.1174 13.0649 15.5123 13.3665 16.4867 13.8236C17.5163 14.3066 17.8446 14.8361 17.8446 15.1853Z",
    stroke: "#6F6F6F",
    strokeWidth: 1.389
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.9041d2d5d83247289418c30e08bb29d6.svg";
export { ForwardRef as ReactComponent };